import Vue from 'vue'
import GlpUI from 'glp-ui'
import { ossDownload } from '@/utils/oos'

Vue.use(GlpUI, { download: ossDownload, previewOffice: (url: string) => window.open(`http://officeapps.glp168.com/op/view.aspx?src=${encodeURIComponent(url)}`) })
